module.exports = __webpack_public_path__ + "static/media/chokha-dine1.13992321.jpg";